import { ChangeEvent } from 'react';

import {
    Checkbox,
    TextField,
    Typography } from '@mui/material';


export type ReportUserLimitProps = {
    userLimit: string;
    handleSetUserLimit: (event: ChangeEvent<HTMLInputElement>) => void;
    handleSetUserLimitDisabled: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    userLimitDisabled: boolean;
}

export const ReportUserLimit = ({ userLimit, handleSetUserLimit, userLimitDisabled, handleSetUserLimitDisabled }: ReportUserLimitProps) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <TextField
                value={userLimit}
                onChange={handleSetUserLimit}
                disabled={userLimitDisabled}
                style={{ marginRight: '1rem' }}
                label={'Number of Users'}
            />
            <Checkbox
                value={userLimitDisabled}
                onChange={handleSetUserLimitDisabled}
            />
            <Typography>
            All users
            </Typography>
        </div>
    );
};
